import dayjs from "dayjs";
import { Item__Atividades, ItemPropriedades } from "../../../../../services/atividades/GET";
import { removerAcentos } from "../../../../../utils";

export function filtroPadrao(data_atividades: Item__Atividades[], data_propriedades: ItemPropriedades[], cod_propriedade_selecionada:number, cod_talhao_selecionado:number, cod_subarea_selecionada:number) {
    
    let atividades_ativas = (data_atividades??[])?.filter(i=>i.delete_time===null);
    
        
    if (Number(cod_subarea_selecionada)>0) {

        let atividades_filtradas = (atividades_ativas??[]).filter(i=> i.cod_talhao === cod_subarea_selecionada || i.cod_talhao === cod_talhao_selecionado);
        //@ts-ignore
        let talhoes = (data_propriedades??[]).map(i=>i.talhao)?.flat()?.filter(j=> j.cod_talhao === null);
        //@ts-ignore
        let subareas = (data_propriedades??[]).map(i=>i.talhao)?.flat()?.filter(j=> j.cod_talhao !== null);

        let incluir_info = (atividades_filtradas??[]).map((item)=> { 
            return { 
                ...item, 
                tipo_filtro: item.cod_talhao === cod_subarea_selecionada ? 'subarea' : 'talhao',
                nome_talhao: (talhoes??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
                nome_subarea: (subareas??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
                nome_subcard: (talhoes??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
            } 
        });
        let apenas_subs = (incluir_info??[]).filter(i=> i.tipo_filtro==='subarea')?.map(j=>j.cod_referencia);

        return (incluir_info??[]).filter(item=> apenas_subs?.includes(item.cod) || item.tipo_filtro==='subarea')
    }
    
    if (Number(cod_talhao_selecionado)>0) {
        
        //@ts-ignore
        let talhoes = (data_propriedades??[]).map(i=>i.talhao)?.flat()?.filter(j=> j.cod_talhao === null);
        //@ts-ignore
        let subareas = (data_propriedades??[]).map(i=>i.talhao)?.flat()?.filter(j=> j.cod_talhao !== null);

        let subareas_do_talhao = (subareas??[]).filter(i=> i.cod_talhao === cod_talhao_selecionado)?.map(j=> j.cod);
        let atividades_filtradas = (atividades_ativas??[]).filter(i=> i.cod_talhao === cod_talhao_selecionado || subareas_do_talhao?.includes(i.cod_talhao) );
        return (atividades_filtradas??[]).map((item)=> { 
            return { 
                ...item, 
                tipo_filtro: item.cod_talhao === cod_talhao_selecionado ? 'talhao' : 'subarea',
                nome_talhao: (talhoes??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
                nome_subarea: (subareas??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
                nome_subcard: (subareas??[]).find(i=> i.cod === item?.cod_talhao)?.nome ?? '',
            } 
        })
    }
    
    if (Number(cod_propriedade_selecionada)>0) {
        let atividades_filtradas = (atividades_ativas??[]).filter(i=> i.cod_propriedade === cod_propriedade_selecionada);
        return (atividades_filtradas??[]).map((item)=> { return { ...item, tipo_filtro: 'propriedade', nome_talhao: '?', nome_subarea: '?' } })
    }

    return (atividades_ativas??[]).map((item)=> { return { ...item, tipo_filtro: 'geral', nome_talhao: '?', nome_subarea: '?' } })
}

type typeFiltros = {
    data_atividades: Item__Atividades[],
    filtrar_titulo: string,
    filtrar_tipos_operacao: {descr: string, id: number, key: number}[],
    filtrar_intervalo_inicial: string,
    filtrar_intervalo_final: string,
    cod_propriedade_selecionada: number,
    cod_talhao_selecionado: number,
    cod_subarea_selecionada: number,
    data_propriedades: ItemPropriedades[]

}
export function filtrosAvancados(filtros: typeFiltros): Item__Atividades[] {

    const { data_atividades, filtrar_titulo, filtrar_tipos_operacao, filtrar_intervalo_inicial, filtrar_intervalo_final, 
    cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada, data_propriedades } = filtros;

    let possui_filtro = filtrar_titulo || filtrar_tipos_operacao.length > 0 || filtrar_intervalo_inicial || filtrar_intervalo_final;

    if (!possui_filtro) {
        return filtroPadrao(data_atividades, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);
    }


    let lista_atividades: any[] = filtroPadrao(data_atividades, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);
    let sempre_manter_dia_zero: Item__Atividades = (lista_atividades??[])?.find(i=> i?.dias === 0 && i?.cod_tipo === 1) as Item__Atividades ?? null;

    let apenas_planejadas = (lista_atividades??[]).filter(i=> i.cod_tipo === 1);
    let apenas_executadas = (lista_atividades??[]).filter(i=> i.cod_tipo === 2);

    //#region TITULO
    if (filtrar_titulo!=='' && filtrar_titulo!==null && filtrar_titulo!==undefined) {

        function findTitulo(buscar_nome: string) {
            const descricaoSemAcento = removerAcentos(buscar_nome);
            return function (item) {
                const nomeSemAcentos = removerAcentos(String(item?.['descricao']));
                return nomeSemAcentos.toLowerCase().includes(descricaoSemAcento.toLowerCase()) || !buscar_nome
            }
        }

        let filtrar_por_titulo = (apenas_planejadas??[]).filter(findTitulo(filtrar_titulo));

        apenas_planejadas = [...filtrar_por_titulo, ...apenas_executadas];
    }
    //#endregion
    
    //#region OPERAÇÕES
    if (filtrar_tipos_operacao?.length > 0) {
        let cods_operacoes = (filtrar_tipos_operacao??[]).map(i=> i.id);

        let filtrar_por_operacao = (apenas_planejadas??[]).filter(item=> cods_operacoes.includes(item.cod_operacao));

        apenas_planejadas = [...filtrar_por_operacao, ...apenas_executadas]
    }
    //#endregion
    
    //#region DATAS
    if (filtrar_intervalo_inicial!=='' && filtrar_intervalo_inicial!==null && filtrar_intervalo_inicial!==undefined) {

        let data_inicial = dayjs(filtrar_intervalo_inicial).format('YYYY-MM-DD');
        let data_final = dayjs(filtrar_intervalo_final).format('YYYY-MM-DD');

        let filtrar_por_intervalo_datas = (apenas_planejadas??[]).filter(item=> item.data_inicio >= data_inicial && item.data_inicio <= data_final);

        apenas_planejadas = [...filtrar_por_intervalo_datas, ...apenas_executadas]
    }
    //#endregion

    let dia_zero_oculto = sempre_manter_dia_zero ? {...sempre_manter_dia_zero, oculto: true} : null;
    let lista_com_dia_zero: Item__Atividades[] = dia_zero_oculto ? [...apenas_planejadas, dia_zero_oculto] : apenas_planejadas;
        
    return lista_com_dia_zero ?? [];
}

//#TOOLTIP CADASTRAR
export function tooltipCadatrar(cod_talhao_selecionado:number, permissao_alterar: boolean):string {
    if (!permissao_alterar) {
        return cod_talhao_selecionado ? "(Sem permissão) Cadastrar atividade ou execução" : '(Sem permissão) Selecione um talhão para liberar o cadastro de atividade!';
    }

    return cod_talhao_selecionado ? "Cadastrar atividade ou execução" : 'Selecione um talhão para liberar o cadastro de atividade!';
}